import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M8.279 1.304a.75.75 0 0 0-.558 0l-5 2A.75.75 0 0 0 2.25 4v6c0 .066.009.13.026.194.309 1.156 1.189 2.122 2.178 2.857 1.004.746 2.209 1.32 3.325 1.666a.752.752 0 0 0 .442 0c1.116-.345 2.321-.92 3.325-1.666.989-.735 1.869-1.701 2.179-2.857A.752.752 0 0 0 13.75 10V4a.75.75 0 0 0-.472-.696l-5-2ZM3.75 7.75v2.144c.208.66.77 1.338 1.599 1.953a9.508 9.508 0 0 0 1.901 1.078V7.75h-3.5Zm5 5.175a9.508 9.508 0 0 0 1.901-1.078c.828-.615 1.391-1.293 1.599-1.953V7.75h-3.5v5.175Zm3.5-6.675V4.508l-3.5-1.4V6.25h3.5Zm-5-3.142V6.25h-3.5V4.508l3.5-1.4Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c
];
function r(d, a) {
  return e(), t("svg", l, [...n]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
